import {observable, action, runInAction} from 'mobx'
import {json, _encodeParam, get} from "../../../utils/ajax";
import {message} from 'antd'
import {downLoad, handleSearchAndPage, setStore, ValueObjToObj} from "../../../utils/Utils";

class carseriesConfigurationStore {
    @observable list  //主列表数据
    @observable pagination  //主列表分页
    @observable driveModel  //驱动方式
    @observable carseriesCode  //车系
    @observable displacement  //发动机排量
    @observable emissionNormal  //排放标准
    @observable deploy  //配置
    @observable transmission  //变速器
    @observable selectCarCode  //车系code
    @observable initTableSelectData//初始化下拉数据

    @observable carYear  //年款
    @observable searchFields  //搜索表单绑定
    @observable editVisible  //修改框是否显示属性
    @observable editFields  //修改回显字段
    @observable confirmLoading  //修改确认
    @observable showDrawer
    @observable carSeriesCodeValue
    @observable endOpen
    @observable times
    @observable editModalStatus   //修改模态框
    @observable exportModal  //导出模态框

    @observable versionNumbert  //版本号
    @observable versionVisible  //查看版本号
    @observable versionList  //查看版本号
    @observable versionPagination  //查看版本号
    @observable carMaterialCode  //整车物料号
    @observable versionFields  //查看版本号
    @observable versionLoading  //查看版本号

    @observable versionListVisible
    @observable versionListPagination
    @observable wholeVehicleVersion
    @observable productionCenter
    @observable versionListLoading

    constructor() {
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.driveModel = [] //驱动方式
        this.displacement = []  //发动机排量
        this.emissionNormal = []  //排放标准
        this.deploy = []  //配置
        this.transmission = []  //变速器
        this.carseriesCode = [] //车系
        this.carYear = [] //年款
        this.searchFields = {
            carmaterialCodeOrCarmaterialName: '',
            carseriesCode: '',
            transmission: '',
            carYear: '',
            deploy: '',
            emissionNormal: '',
            displacement: '',
            driveModel: '',
            interiorColor: ''
        }
        this.editVisible = false
        this.editFields = {
            carMaterialCode: ''
        }
        this.confirmLoading = false
        this.showDrawer = false
        this.carSeriesCodeValue = ''
        this.endOpen = false
        this.times = []
        this.modelStatus = false
        this.selectCarCode = ''
        this.initTableSelectData = {
            modelYearSet: [],
            powerSet: [],
            transTypeSet: [],
            driveTypeSet: [],
            displacementSet: [],
            allocationSet: [],
        }
        this.editModalStatus = false
        this.exportModal = false

        this.versionNumbert=[]
        this.versionList=[]
        this.versionVisible=false
        this.versionPagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.carMaterialCode=''
        this.versionFields={
            materialName:'',
            materialNo:''
        }
        this.versionLoading=false

        this.versionListVisible=false
        this.versionListLoading=false
        this.wholeVehicleVersion=''
        this.versionListPagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 10,
            showTotal: () => {
            }
        }
        this.productionCenter=''

    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /*** 页面初始化*/
    @action
    initPage = async (page) => {
        this.loading = true
        let searchFields = {
            carmaterialCodeOrCarmaterialName: this.searchFields.carmaterialCodeOrCarmaterialName ? this.searchFields.carmaterialCodeOrCarmaterialName : '',
            carseriesCode: this.searchFields.carseriesCode ? this.searchFields.carseriesCode : '',
        }
        let search = handleSearchAndPage(page, this.pagination, searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            // this.initSelectValues()
        })
    }

    /***搜索框车系数据 ***/
    @action
    initCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseries:search`)
        runInAction(() => {
            this.carseriesCode = Array.isArray(res) ? res : []
        })
    }

    /***
     * 选择车系后请求配置数据
     * @param value
     */
    @action
    selectCarData = (value) => {
        this.selectCarCode = value
        this.changeSelectData('', 0, '')
    }

    /**
     * 获取配置下拉数据
     * @returns {Promise<void>}
     */
    @action
    changeSelectData = async (value, index, label) => {
        let search = {}
        Object.keys(this.searchFields).forEach(key => {
            if (this.searchFields[key]) {
                search[`search.${key}`] = [this.searchFields[key]]
            }
            if (key === label) {
                search[`search.${key}`] = [value]
            }
        })
        search[`search.carseriesCode`] = this.selectCarCode
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getConfigOption`, search)
        runInAction(() => {
            this.initTableSelectData = {...this.initTableSelectData, ...res}
        })
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        this[fields] = {...this[fields], ...changedFields}
    }

    /*** 绑定主页面搜索框值****/
    @action
    onEditFormField = (changeFields, fields) => {
        const change = ValueObjToObj(changeFields)
        this[fields] = {...this[fields], ...change}
    }

    /***导出*/
    @action
    getUrl = () => {
        const url = `${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/export/excel/all`
        return `${url}?${_encodeParam()}`
    }

    /*** 清空搜索框*/
    @action
    clearForm = () => {
        this.searchFields = {
            carmaterialCodeOrCarmaterialName: '',
            carseriesCode: '',
        }
        this.initPage()
    }

    /**打开修改***/
    @action
    editModal = async (id) => {
        this.editVisible = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/selectById/${id}`)
        runInAction(() => {
            this.editFields = res
            this.editModalStatus = true
        })
    }

    /****确认修改**/
    @action
    saveEdit = async () => {
        this.confirmLoading = true
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/updateById`, this.editFields)
        if (res.status) {
            runInAction(() => {
                message.success('修改成功')
                this.editVisible = false
                this.editModalStatus = false
                this.confirmLoading = false
            })
            this.initPage(this.pagination.current)
        } else {
            runInAction(() => {
                this.confirmLoading = false
                message.error('修改失败')
            })
        }
    }

    /**删除***/
    @action
    deleteRow = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/delById/id/${id}`)
        if (res.status === 1) {
            message.success(res.data)
        } else {
            message.warn(res.msg)
        }
        this.initPage()
    }

    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /**
     * 关闭导出框
     */
    @action
    handleExportVisible = () => {
        this.endOpen = false
        this.times = []
        this.carSeriesCodeValue = ''
        this.exportModal = true
    }

    /***一键匹配车系 ***/
    @action
    matchingCarSeries = async () => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/matchCarSeries`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        this.initPage()
    }

    /**查看版本号***/
    @action
    showVersion = async (page) => {
        let searchFields = {
            carMaterialCode: this.carMaterialCode,
            wholeVehicleVersion:  ''
        }
        this.versionListLoading=true
        let search = handleSearchAndPage(page, this.versionListPagination, searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/instantiateTheAssembly/vehicleVersionNumber`,search)
        if (res && (res.content) ) {
            runInAction(() => {
                this.versionNumbert= res.content || []
                this.versionListVisible=true
                this.versionListLoading=false
                this.versionListPagination = {
                    current: res.number + 1,
                    total: res.totalElements,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    pageSize: res.size,
                    showTotal: () => `总共 ${res.totalElements} 条`
                }
            })
        }
    }


    /**查看版本号***/
    @action
    showVersionList = async (page) => {
        this.versionLoading = true
        let searchFields = {
            carMaterialCode: this.carMaterialCode,
            wholeVehicleVersion: this.wholeVehicleVersion,
            productionCenter:this.productionCenter,
            materialNo: this.versionFields.materialNo ? this.versionFields.materialNo : '',
            materialName: this.versionFields.materialName ? this.versionFields.materialName : '',
        }
        let search = handleSearchAndPage(page, this.versionPagination, searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/instantiateTheAssembly/listOfVehicleVersionNumberData`, search)
        if (res && (res.content) ) {
            runInAction(() => {
                this.versionList= res.content || []
                this.versionPagination = {
                    current: res.number + 1,
                    total: res.totalElements,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    pageSize: res.size,
                    showTotal: () => `总共 ${res.totalElements} 条`
                }
            })
        }
        this.versionLoading=false
    }

    @action
    clearVersionForm=()=>{
        this.versionFields={}
    }

    @action
    versionExport=()=>{
        downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/instantiateTheAssembly/theInstantiatedVersionExportsPartInformation?carMaterialCode=${this.carMaterialCode}&productionCenter=${this.productionCenter}&wholeVehicleVersion=${this.wholeVehicleVersion}`, `${this.carMaterialCode}-${this.wholeVehicleVersion}.xls`)
    }

}

export default new carseriesConfigurationStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/CarseriesConfiguration/store.js